export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6m-5051d3db62312b8fa4f0bcc5759d3cd3.webp";